import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { ComboCliente, ComboGrupo, ComboInformesTipos } from '../../../core/model/combos';
import { InformesSearch, InformesUpload } from '../../../core/model/informes';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { InformesService } from '../../../core/services/informes/informes.service';
import { FileQueueObject, FileUploaderService } from '../../../core/services/informes/upload-file.service';
import { PopulateService } from '../../../core/services/populate.service';
// Modal confirmation
import { ModalConfirmationComponent } from '../../../utils/modal-confirmation/modal-confirmation.component';





@Component({
  selector: 'app-uploadinformes',
  templateUrl: './uploadinformes.component.html',
  styleUrls: ['./uploadinformes.component.css'],
  providers: [BsModalService]
})
export class UploadinformesComponent implements OnInit, OnDestroy {

  @Output() CompleteItem = new EventEmitter();
  @Output() ErrorItem = new EventEmitter();
  @Output() ProgressItem = new EventEmitter();
  @Output() CancelItem = new EventEmitter();


  @ViewChild('fileInput') fileInput;
  @ViewChild('templateconfirm') templateconfirm;

  queue: Observable<FileQueueObject[]>;

  Boxtype = 'box-primary';
  Title: string;
  Description: string;
  Padre: string;
  Hijo: string;

  isDocoutUser: boolean;

  statusCode: number;
  mensajeToShow: string;
  requestProcessing: boolean;

  months: any;
  years: any;
  cbCliente: ComboCliente[];
  cbGrupo: ComboGrupo[];
  cbtipoInformes: ComboInformesTipos[];

  uploadChecker: InformesSearch = new InformesSearch();
  existeInforme: Observable<number>;
  overwrite: boolean;
  informeIdUpdate: number;

  informeupload: InformesUpload;
  private item: any;
  processValidation = false;

  clienteSeleccionado = undefined;

  private subscription;
  private subscription_change;
  private subscription_tipos;
  private subscription_informes;
  private subscription_clientes;
  private subscription_grupos;

  // Creamos el formulario
  uploadForm = new FormGroup({
    cliente: new FormControl(undefined, [Validators.required]),
    grupo: new FormControl(undefined, [Validators.required]),
    tipo: new FormControl('', [Validators.required]),
    mes: new FormControl('', [Validators.required]),
    ano: new FormControl('', [Validators.required]),
    inputfile: new FormControl('', [Validators.required])
  });

  message: string;

  constructor(private toastr: ToastrService,
    private modalservice: BsModalService,
    private translateService: TranslateService,
    private authService: AuthenticationService,
    private informesservice: InformesService,
    private populateservice: PopulateService,
    public uploader: FileUploaderService) { }

  // region Inicializar
  ngOnInit() {
    this.SetEnviroment();
    this.InitUploader();
    this.InitLanguage();
    this.getFilters();
  }

  ngOnDestroy() {
    this.toastr = null;
    this.translateService = null;
    this.authService = null;
    this.populateservice = null;
    this.informesservice = null;
    this.uploader = null;
    this.modalservice = null;
    this.existeInforme = null;

    if (!this.subscription == null) { this.subscription.unsubscribe(); }
    if (!this.subscription_change == null) { this.subscription_change.unsubscribe(); }
    if (!this.subscription_tipos == null) { this.subscription_tipos.unsubscribe(); }
    if (!this.subscription_informes == null) { this.subscription_informes.unsubscribe(); }
    if (!this.subscription_clientes == null) { this.subscription_clientes.unsubscribe(); }
    if (!this.subscription_grupos == null) { this.subscription_grupos.unsubscribe(); }

  }

  SetEnviroment() {
    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;
      });

    this.authService.getClienteName$().subscribe(beadcrumbDad => {
      this.Padre = beadcrumbDad;
    }).unsubscribe();
  }

  InitLanguage() {
    this.subscription = this.translateService.get(['informes'])
      .subscribe(values => { this.TranslateText(values); });

    this.subscription_change = this.translateService.onLangChange.subscribe(() => {
      this.translateService.get(['informes'])
        .subscribe(values => { this.TranslateText(values); });
    });
  }
  TranslateText(values: any) {
    this.Title = values['informes']['upcabecera'];
    this.Description = values['informes']['updescripcion'];
    this.Hijo = values['informes']['upcabecera'];
  }

  // endregion


  // region "Uploader componente"
  InitUploader() {
    this.queue = this.uploader.queue;
    this.uploader.onCompleteItem = this.completeItem;
    this.uploader.onErrorItem = this.errorItem;
    this.uploader.onProgressItem = this.progressItem;
    this.uploader.onCancelItem = this.cancelItem;
    // this.uploader.onDeleteItem = this.deleteItem;
  }

  completeItem = (item: FileQueueObject, response: any) => {
    this.CompleteItem.emit({ item, response });
    this.toastr.success('Se ha subido su informe ' + item.infofile.FILENAME, 'Subida correcta');
  }

  errorItem = (item: FileQueueObject, response: any) => {
    this.ErrorItem.emit({ item, response });
    this.toastr.error('No se podido subir su informe ' + item.infofile.FILENAME, 'Subida errónea');
    // response.Message
  }

  progressItem = (item: FileQueueObject) => {
    this.ProgressItem.emit({ item });
  }

  cancelItem = (item: FileQueueObject) => {
    this.CancelItem.emit({ item });
    this.toastr.warning('Cancelando ' + item.infofile.FILENAME, 'Subida cancelada');
  }


  addToQueue() {
    const fileBrowser = this.fileInput.nativeElement;
    this.informeupload = new InformesUpload();

    this.informeupload.ID_TIPO_INFORME = this.uploadForm.controls['tipo'].value;
    this.informeupload.ID_GRUPO = this.uploadForm.controls['grupo'].value;
    this.informeupload.ANO = this.uploadForm.controls['ano'].value;
    this.informeupload.MES = this.uploadForm.controls['mes'].value;
    this.informeupload.OVERWRITE = this.overwrite;
    this.informeupload.ID = this.informeIdUpdate;

    this.informeupload.NOMBRE_CLIENTE = this.getSelectedText(this.uploadForm.controls['cliente'].value, this.cbCliente);
    this.informeupload.NOMBRE_GRUPO = this.getSelectedText(this.informeupload.ID_GRUPO, this.cbGrupo);
    this.informeupload.NOMBRE_INFORME = this.getSelectedText(this.informeupload.ID_TIPO_INFORME, this.cbtipoInformes);
    this.informeupload.NOMBRE_MES = this.getSelectedText(this.informeupload.MES, this.months);

    this.informeupload.GUID = '',
      this.informeupload.FILENAME = fileBrowser.files[0].name;
    this.uploader.addToQueue(fileBrowser.files, this.informeupload);
    this.informeupload = null;
    // limpiamos el input
    this.fileInput.nativeElement.value = '';
    // limpiamos el formulario
    this.resetForm();

  }

  // endregion

  // region "filtros"

  getFilters() {
    this.getClientes();
    this.getTipoInformes();
    this.getMonth();
    this.getYears();
  }

  getClientes() {
    this.subscription_clientes = this.populateservice.getComboCliente()
      .subscribe(
        clientes => {
          this.cbCliente = clientes;
          // this.requestProcessingTipo = false;
          // this.toastr.info('Direcciones cargadas correctamente', 'Carga correcta');
        },
        errorCode => {
          this.errorCode();
        });


  }

  getGroupByCliente(identificador: number) {
    this.subscription_grupos = this.populateservice.getComboGrupoByCliente(identificador)
      .subscribe(
        grupo => {
          this.cbGrupo = grupo;
        },
        errorCode => {
          this.errorCode();
        });


  }

  getTipoInformes() {

    this.preProcessUpload('Recuperando información..');
    this.subscription_tipos = this.populateservice.getComboTipoInformes()
      .subscribe(
        data => {
          this.cbtipoInformes = data;
          this.requestProcessing = false;
        },
        errorCode => {
          this.errorCode();
        });
  }

  getYears() {
    this.years = [];
    const actual = new Date().getFullYear();
    for (let x = 0; x <= 5; x++) {
      this.years.push({ value: actual - x, name: '' + (actual - x) });
    }
  }

  getMonth() {
    this.months = [
      { Id: 1, NOMBRE: 'Enero' },
      { Id: 2, NOMBRE: 'Febrero' },
      { Id: 3, NOMBRE: 'Marzo' },
      { Id: 4, NOMBRE: 'Abril' },
      { Id: 5, NOMBRE: 'Mayo' },
      { Id: 6, NOMBRE: 'Junio' },
      { Id: 7, NOMBRE: 'Julio' },
      { Id: 8, NOMBRE: 'Agosto' },
      { Id: 9, NOMBRE: 'Septiembre' },
      { Id: 10, NOMBRE: 'Octubre' },
      { Id: 11, NOMBRE: 'Noviembre' },
      { Id: 12, NOMBRE: 'Diciembre' }
    ];

    this.translateService.get(['meses'])
      .subscribe(values => {
        for (let i = 0, len = this.months.length; i < len; i++) {
          this.months[i].NOMBRE = values['meses'][this.months[i].Id];
        }
      }).unsubscribe();

  }


  // endregion



  uploadFileForm() {

    // rellenamos el filtro InformesSearch
    this.uploadChecker.ANO = this.uploadForm.controls['ano'].value;
    this.uploadChecker.ID_CLIENTE = this.uploadForm.controls['cliente'].value;

    this.uploadChecker.ID_GRUPO = this.uploadForm.controls['grupo'].value;
    this.uploadChecker.ID_TIPO_INFORME = this.uploadForm.controls['tipo'].value;
    this.uploadChecker.MES = this.uploadForm.controls['mes'].value;



    this.CompruebaInforme();

    const subscription = this.existeInforme.subscribe(
      value => {
        this.informeIdUpdate = value;
        if (value !== 0) {
          this.overwrite = true;
          this.showConfirmationModal();
        } else {
          this.overwrite = false;
          this.openFileInput();
        }
        this.requestProcessing = false;
      }
    );

  }


  // region "Generico"
  changeFileName() {
    const fileBrowser = this.fileInput.nativeElement;
    this.uploadForm.patchValue({ inputfile: fileBrowser.files[0].name });
  }


  resetForm() {
    if (this.uploadForm != null) {
      this.uploadForm.setValue({
        cliente: undefined,
        grupo: undefined,
        tipo: '',
        mes: '',
        ano: '',
        inputfile: ''
      });
      // Reiniciamos combos dependientes
      this.onClientChange(undefined);
    }
  }

  onClientChange(idcliente: number) {
    this.uploadForm.patchValue({ grupo: undefined });
    this.cbGrupo = [];

    if (idcliente && idcliente != 0) {
      this.getGroupByCliente(idcliente);
    }
  }
  errorCode() {
    this.statusCode = 500;
    this.translateService.get(['mensajes'])
      .subscribe(values => {
        this.toastr.warning(values['mensajes']['nodata'],
          values['mensajes']['nodatatitle']);
      });
  }
  preProcessUpload(mensaje: string) {
    this.statusCode = null;
    this.requestProcessing = true;
    this.mensajeToShow = mensaje;
  }
  // endregion


  CompruebaInforme() {
    this.preProcessUpload('Comprobando informe ...');

    this.existeInforme = new Observable(observer => {
      this.informesservice.getAllInformes(this.uploadChecker)
        .subscribe(
          data => {
            if (data.length <= 0 || data == null) {
              // this.informeIdUpdate = 0;
              // this.overwrite = false;
              observer.next(0);
            } else {
              // this.informeIdUpdate = data[0].ID;
              // this.overwrite = true;
              observer.next(data[0].Id);
            }
            this.requestProcessing = false;
          },
          errorCode => {
            // si hay error lo ponemos como sobreescribir para comproabr el servicio
            this.informeIdUpdate = 0;
            this.overwrite = true;
            observer.next(0);
          });
      // observer.complete();
    });

  }



  public getSelectedText(value: number, cblista: any): string {
    let texto = '';
    if (cblista && value) {
      // tslint:disable-next-line:triple-equals
      this.item = cblista.find(s => s.Id == value);
      texto = this.item.NOMBRE;
    }

    return texto;
  }

  // region "Aviso sobreescritura"

  public showConfirmationModal(): void {
    const modal = this.modalservice.show(ModalConfirmationComponent);
    (<ModalConfirmationComponent>modal.content).showConfirmationModal(
      'Aviso de sobreescritura',
      'El informe que está intentando subir ya existe. ¿Desea sobreescribirlo?',
      '',
      'Si',
      'No',
      true,
      'fa-exclamation-triangle fa-3x',
      'bg-danger'
    );

    (<ModalConfirmationComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        // when pressed Yes
        this.openFileInput();
      } else if (result === false) {
        // when pressed No
      } else {
        // When closing the modal without no or yes (esc or click backdrop)
      }
    });
  }


  // endregion


  openFileInput() {
    this.addToQueue();
    // const fileBrowser = this.fileInput.nativeElement;
    // fileBrowser.click();
  }

}
